import {
    FC, FunctionComponent, SVGProps, useEffect, useState
} from 'react';
import { useTranslation } from 'react-i18next';
import DropdownItem from './DropdownItem/DropdownItem';
import DropdownComponent, { ItemToggler, DropdownSearchInput } from './Style';
import { ReactComponent as ChevronDownIcon } from '../../Assets/icons/ic_chevron_down.svg';
import { ReactComponent as ChevronUpIcon } from '../../Assets/icons/ic_chevron_up.svg';
import { themeProvider } from '../../Theme/ThemeProvider';
import Constants from '../../../Utils/Constants';
import useStepContext from '../../Hooks/useStepContext';
import ClickAwayListener from '../ClickAwayListener/ClickAwayListener';

export interface IDropdownItem { // TODO: improve this interface
    id: number,
    key: string,
    description: string,
    value?: string,
    // Note that the description property MUST ONLY be provided
    // if the list to which the item belongs to  must be ordered following a given rule
    icon?: FunctionComponent<SVGProps<
    SVGSVGElement
  > & { title?: string }>
}
interface IProps {
    items: IDropdownItem[];
    onSelect: (item: IDropdownItem) => void;
    isInput?: boolean,
    defaultItem: IDropdownItem,
    disabled: boolean,
    identifier?: string,
    isDesktop?: boolean;
    isSearchable?: boolean;
    placeholder?: string;
}

const Dropdown: FC<IProps> = ({
    items, onSelect, isInput, defaultItem, disabled, identifier, isDesktop, isSearchable = false,
    placeholder = 'Search...'
}) => {
    const { t } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);
    const [search, setSearch] = useState('');
    const [selectedItem, setSelectedItem] = useState<IDropdownItem>(defaultItem);

    useEffect(() => {
        setSelectedItem(defaultItem);
    }, [defaultItem]);

    const selectItemHandler = (selectedItem: any) => {
        onSelect(selectedItem);
        setIsOpen(!isOpen);
        setSearch('');
    };

    const toggleDropdown = () => {
        if (!disabled) {
            setIsOpen(!isOpen);
            setSearch('');
        }
    };
    const filteredItems = isSearchable
        ? items.filter((item) => t(item.key).toLowerCase().includes(search.toLowerCase())
            || item.description?.toLowerCase().includes(search.toLowerCase())
        )
        : items;

    return (
        <>
            <ItemToggler
                isInput={isInput}
                labelColor={disabled ? themeProvider.inputColor : themeProvider.darkGrey}
                onClick={toggleDropdown}
                className="item-toggler"
                role="button"
                tabIndex={0}
                id={`${identifier}-dropdown-toggler`.replace(/\s+/g, '').toLowerCase()}
                isDesktop={isDesktop}
            >
                <span className="item__description">
                    {/* {selectedItem.key.includes('othersType') ? selectedItem.description : t(selectedItem.key)} */}
                    {/* {t(defaultItem.description) || t(defaultItem.key)} */}
                    {t(selectedItem?.description) || t(selectedItem?.key) || t(defaultItem?.description) || t(defaultItem?.key)}

                </span>
                {!disabled && (
                    <>{(isInput && isOpen)
                        ? <ChevronUpIcon className="item-toggler__chevron" />
                        : <ChevronDownIcon className="item-toggler__chevron" />}
                    </>
                )}
            </ItemToggler>
            {isOpen && (
                <ClickAwayListener onClick={toggleDropdown}>
                    <DropdownComponent
                        isInput={isInput}
                    >
                        {isSearchable && (
                            <DropdownSearchInput
                                type="text"
                                placeholder={placeholder}
                                value={search}
                                onChange={(e) => setSearch(e.target.value)}
                            />
                        )}
                        {filteredItems.map((item) => (
                            <span
                                id={`dropodwn-item-${item.key}`}
                                key={item.key}
                                role="button"
                                tabIndex={0}
                                onClick={() => selectItemHandler(item)}
                            >
                                <DropdownItem
                                    item={item}
                                    selectedOption={selectedItem}
                                />
                            </span>
                        ))}
                    </DropdownComponent>
                </ClickAwayListener>
            )}
        </>
    );
};
export default Dropdown;
